// @dynamic-i18n-keys
// Dynamic t() at lines 57, 70 (replaceCta | attachCta):
//   deviationSubmit.modals.legalDocuments.replaceCta
//   deviationSubmit.modals.legalDocuments.attachCta
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DocumentUploadField from '@wix/da-shared-react/pkg/DocumentUploadField';
import { LegalDocumentType } from '@wix/da-shared-react/pkg/redux/uploads/types';

import s from './LegalDocumentsPopup.scss';

interface Props {
  deviationId: number;
  narfDocumentUrl?: string;
  sprfDocumentUrl?: string;
  requestClose: () => void;
  onUploadComplete: (documentType: LegalDocumentType, documentUrl: string) => void;
}

const LegalDocumentsPopup: React.FC<Props> = ({
  deviationId,
  narfDocumentUrl,
  sprfDocumentUrl,
  requestClose,
  onUploadComplete,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      heading={t('deviationSubmit.modals.legalDocuments.title')}
      layoutClassName={s['modal-layout']}
      contentClassName={s['modal-content']}
      onRequestClose={requestClose}
      showHeaderBorder
      showFooterBorder
      withScrollableContentWrapper={false}
      footerRight={[
        <TextButton key="cancel" variant="main" size="large" onClick={requestClose}>
          {t('deviationSubmit.modals.legalDocuments.closeCta')}
        </TextButton>,
      ]}
    >
      <div className={s['subheading']}>{t('deviationSubmit.modals.legalDocuments.subheading')}</div>

      <DocumentUploadField
        label={t('deviationSubmit.modals.legalDocuments.sprfLabel')}
        uploadButtonLabel={t(
          `deviationSubmit.modals.legalDocuments.${sprfDocumentUrl ? 'replaceCta' : 'attachCta'}`
        )}
        viewButtonLabel={t('deviationSubmit.modals.legalDocuments.viewCta')}
        deviationId={deviationId}
        documentType="sprf"
        documentUrl={sprfDocumentUrl}
        onUploadComplete={onUploadComplete}
      />
      <DocumentUploadField
        label={t('deviationSubmit.modals.legalDocuments.narfLabel')}
        uploadButtonLabel={t(
          `deviationSubmit.modals.legalDocuments.${narfDocumentUrl ? 'replaceCta' : 'attachCta'}`
        )}
        viewButtonLabel={t('deviationSubmit.modals.legalDocuments.viewCta')}
        deviationId={deviationId}
        documentType="narf"
        documentUrl={narfDocumentUrl}
        onUploadComplete={onUploadComplete}
      />
    </Modal>
  );
};
LegalDocumentsPopup.displayName = 'LegalDocumentsPopup';

export default LegalDocumentsPopup;
